import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/zakelijk",
    name: "zakelijk",
    component: () => import("../views/forms/ZakelijkeAanvraagForm.vue"),
  },
  {
    path: "/subsidie-check",
    redirect: (to) => ({ path: '/kozijnen', query: to.query, hash: to.hash }),
  },
  {
    path: "/kozijnen",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
  {
    path: "/schuifpui",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
  {
    path: "/deuren",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
  {
    path: "/voordeur",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
   {
    path: "/achterdeur",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
  {
    path: "/horren",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/forms/__template"),
    children: [
      {
        path: "",
        component: () => import("../views/forms/OfferteAanvraagForm"),
      },
    ],
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
